export const perpetualMassFormNames = {
  agreeOnRegulations: 'agreeOnRegulations',
  email: 'email',
  fullName: 'full_name',
  offeringAmount: 'offering_amount',
  offeringContent: 'offering_content',
  offeringType: 'offering_type',
  phone: 'phone',
  showAddress: 'show_address',
  city: 'city',
  street: 'street',
  zipCode: 'zip_code',
  country: 'country',
};
